import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import '../styles/DigitalDurations.scss';

export default function DigitalDurations({ durations, handleSelect }) {
  return (
    <div className="cp-digital-durations">
      <h3><FormattedMessage id="select_a_duration" /></h3>
      <ul>
        {durations.map((duration, index) => (
          <li>
            <label className="duration-label" htmlFor={`digital-duration-${index}`}>
              <input
                id={`digital-duration-${index}`}
                type="radio"
                className="digital-duration"
                name="digital-duration"
                value={duration}
                onChange={() => handleSelect(duration)}
                required />
              <FormattedMessage id="label_duration_length" values={{ days: duration }} />
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

DigitalDurations.propTypes = {
  durations: ImmutablePropTypes.listOf(PropTypes.number),
  handleSelect: PropTypes.func.isRequired
};

DigitalDurations.diplayName = 'DigitalDurations';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-durations/components/DigitalDurations.component.jsx